// extracted by mini-css-extract-plugin
module.exports = {"share-container":"_2P8jYg_G flex","shareContainer":"_2P8jYg_G flex"};